import 'ol/ol.css';
import Map from 'ol/Map';
import OSM from 'ol/source/OSM';
import Stamen from 'ol/source/Stamen';
import TileLayer from 'ol/layer/Tile';
import View from 'ol/View';
import {fromLonLat} from 'ol/proj';
import {Icon, Style} from 'ol/style';
import Feature from 'ol/Feature';
import VectorSource from 'ol/source/Vector';
import {LineString, Point} from 'ol/geom';
import {Vector as VectorLayer} from 'ol/layer';
import Overlay from 'ol/Overlay';
import {FullScreen, defaults as defaultControls} from 'ol/control';

import llista_municipis from './municipis.js';

let municipis = llista_municipis();

//el color està associat a les capes de municipis, segons número d'habitants
//després tenim el nivell de zoom del mapa, que té associat un tamany d'icona
//var capes_mun = [['blue',200000],['orange',100000]]; //també funciona, l'aplicació està totalment parametritzada
var capes_mun = [['blue',200000],['orange',100000],['red',40000],['yellow',20000]];
var capes_zoom = [[48,9], [32,8], [24,7], [16,6]];

/**
 * Elements that make up the popup.
 */
var container = document.getElementById('tooltip');
var content = document.getElementById('tooltip-content');

/**
 * Create an overlay to anchor the popup to the map.
 */
var overlay = new Overlay({
  element: container,
  autoPan: true,
  autoPanAnimation: {
    duration: 250,
  },
});

document.addEventListener("DOMContentLoaded", load, false);

function load() {
  //console.log(currZoom);
	document.getElementById("osm").addEventListener("change", function() {canviar_render('osm');}, false);
	document.getElementById("terrain").addEventListener("change", function() {canviar_render('terrain');}, false);
	document.getElementById("toner").addEventListener("change", function() {canviar_render('toner');}, false);

  for (let i=0; i<capes_mun.length; i++) {
    document.getElementById(capes_mun[i][0]).addEventListener("change", function() {canviar_capa(i,this.checked,currSize);}, false);
  }

}

function canviar_render(str_layer) {
  //var layersOnMap = map.getLayers().getArray();
  //console.log(layersOnMap.length);
  //https://github.com/openlayers/openlayers/issues/3811
	if (str_layer=='osm') {
    map.getLayers().setAt(0, layerOSM);
	} else if (str_layer=='terrain') {
    map.getLayers().setAt(0, layerTerrain);
	} else if (str_layer=='toner') {
    map.getLayers().setAt(0, layerToner);
	}
}

function canviar_capa(id_layer, value, size) {
  if (size > capes_zoom[0][1]) {
    if (value) {
      map.addLayer(vectors[0][id_layer]);
    } else {
      map.removeLayer(vectors[0][id_layer]);
    }
  }

  for (let i=0; i<capes_zoom.length; i++) {
    if (size == capes_zoom[i][1]) {
      if (value) {
        map.addLayer(vectors[i][id_layer]);
      } else {
        map.removeLayer(vectors[i][id_layer]);
      }
    }
  }

  if (size < capes_zoom[capes_zoom.length-1][1]) {
    if (value) {
      map.addLayer(vectors[capes_zoom.length-1][id_layer]);
    } else {
      map.removeLayer(vectors[capes_zoom.length-1][id_layer]);
    }
  }
}

//carreguem l'array d'estils, amb 4 estils diferents
var estils = new Array();
for (let i=0; i<capes_zoom.length; i++) {
  estils.push(new Array())
}

for (let i=0; i<capes_zoom.length; i++) {
  for (let j=0; j<capes_mun.length; j++) {
    estils[i].push(new Style({
    image: new Icon({
      anchor: [capes_zoom[i][0]/2,capes_zoom[i][0]],
      anchorXUnits: 'pixels',
      anchorYUnits: 'pixels',
      src: 'img/location-' + capes_mun[j][0] + '-' + capes_zoom[i][0] + '.png'
    })
    }));
  }
}

var layers_ciutats = new Array();
for (let i=0; i<capes_mun.length; i++) {
  layers_ciutats.push(new Array());
}

var tipus;
for (let i=0; i<municipis.length; i++) {
  
  for (let j=0; j<capes_mun.length; j++) {
    if (municipis[i].hab >= capes_mun[j][1]) {
      tipus = j;
      layers_ciutats[tipus].push(new Feature({
      'geometry': new Point(fromLonLat([municipis[i].lon, municipis[i].lat])),
      'name': municipis[i].nom,
      'hab': municipis[i].hab,
      }))
      break;
    }
  }
}

var vectors = new Array();
for (let i=0; i<capes_zoom.length; i++) {
  vectors.push(new Array())
}

for (let i=0; i<capes_zoom.length; i++) {
  for (let j=0; j<capes_mun.length; j++) {
    vectors[i].push( new VectorLayer({
    source: new VectorSource({ features: layers_ciutats[j] }),
    style: estils[i][j],
  }));
  }
}

let layerOSM = new TileLayer({
  source: new OSM({
    layer: 'OSM',
  }),
})

let layerTerrain = new TileLayer({
  source: new Stamen({
    layer: 'terrain',
  }),
})

let layerToner = new TileLayer({
  source: new Stamen({
    layer: 'toner',
  }),
})

var layers = new Array();
layers.push(layerOSM);
for (let i=0; i<capes_mun.length; i++) {
  layers.push(vectors[0][i])
}

var map = new Map({
  controls: defaultControls().extend([new FullScreen()]),
  layers: layers,
  target: 'map',
  overlays: [overlay],
  view: new View({
    center: fromLonLat([1.8679, 41.5199]),
    zoom: 9,
  }),
});

map.on("pointermove", function(e) {
  var coordinate = e.coordinate;
  map.forEachFeatureAtPixel(e.pixel, function (feature, layer) {
    if (feature.values_.name != undefined) {
      document.getElementById('tooltip').style.visibility="visible";
      var content = document.getElementById('tooltip-content');
      content.innerHTML = feature.values_.name + '<br />';
      content.innerHTML += feature.values_.hab + ' hab'
      overlay.setPosition(coordinate);
      setTimeout(function(){ tancar_tooltip(); }, 2000);
    }
  })
});

function tancar_tooltip() {
  document.getElementById('tooltip').style.visibility = "hidden";
}

var currZoom = map.getView().getZoom();
var currSize = Math.round(currZoom);
//console.log(currZoom);
map.on('moveend', function(e) {
  var newZoom = map.getView().getZoom();
  var newSize = Math.round(newZoom);
  if (currSize != newSize) {
    //console.log('zoom end, new zoom: ' + newZoom);
    console.log(newSize);

    if (newSize==currSize-1 || newSize==currSize+1) {
      for (let i=0; i<capes_mun.length; i++) {
        //primer de tot els esborrem tots
        canviar_capa(i,false,currSize);
        // i ara renderitzem aquells que estiguin seleccionats
        canviar_capa(i,document.getElementById(capes_mun[i][0]).checked,newSize);
      }
    }
    currZoom = newZoom;
    currSize = newSize;
  }
});